<template>
  <div>
    <b-row class="content-header mb-2">
      <!-- Content Left -->
      <b-col class="content-header-left" cols="12" md="9">
        <breadcrumb />
      </b-col>

      <!-- Content Right -->
<!--      <b-col class="content-header-right text-md-right" md="3" cols="12">
        <b-button
          @click="showFormModal(null)"
          class="px-3 text-capitalize"
          variant="primary"
        >
          <feather-icon size="16" icon="PlusIcon" class="mr-50" />
          ایجاد تنظیمات
        </b-button>
      </b-col>-->
    </b-row>
    <div v-if="services">
      <div class="d-flex justify-content-between align-items-center">
         <per-page class="col-sm-12 col-md-3 col-lg-2" v-model="perPage" />
        <!-- <search
          ref="residencesSearchComponent"
          class="w-50"
          v-model="searchInput"
        /> -->
      </div>

      <b-table-simple responsive>
        <b-thead>
          <b-tr>
            <b-th>شماره موبایل</b-th>
            <b-th>تلفن</b-th>
            <b-th>ادرس</b-th>
            <b-th>نمایش</b-th>
            <b-th>عملیات</b-th>
          </b-tr>
        </b-thead>
        <b-tbody>
          <b-tr v-for="service in services" :key="service.id">
            <b-th >{{ service.mobile }}</b-th>
            <b-td>{{ service.phone }}</b-td>
            <b-td>{{ service.address }}</b-td>
            <b-td>
              <span v-if="service.show=='inactive'">
                    شماره دفتر
              </span>
              <span v-else>
                شماره موبایل
              </span>
            </b-td>
            <b-td>
              <b-col class="d-flex align-items-center">
                <b-button
                  @click="showConfirmModal(service)"
                  variant="flat-danger"
                  class="font-weight-bolder"
                >
                  <feather-icon icon="Trash2Icon" size="20" />
                </b-button>
                <b-button
                  @click="showFormModal(service)"
                  variant="flat-secondary"
                  class="font-weight-bolder"
                >
                  <feather-icon icon="Edit2Icon" size="20" />
                </b-button> </b-col
            ></b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>
      <pagination
        ref="residencesPaginationComponent"
        v-model="page"
        :paginationData="paginationData"
      />
    </div>
    <b-sidebar
      width="500px"
      v-model="formModal"
      right
      backdrop
      shadow
      bg-variant="white"
    >
      <template #header>
        <div class="w-100">
          <div class="text-right">
            <b-button
              style="background-color: rgba(75, 75, 75, 0.12)"
              @click="formModal = false"
              variant="flat-dark"
              class="btn-icon rounded-circle mr-1"
            >
              <feather-icon icon="XIcon" size="20" />
            </b-button>
          </div>
          <div class="mr-1 sidebarHeaderTitleDiv">
            <h3 class="text-capitalize">
              {{ editMode ? "ویرایش تنظیمات" : "ایجاد تنظیمات" }}
            </h3>
          </div>
        </div>
      </template>
      <b-container class="">
        <b-form-group class="mt-1">
          <label for="name" class="text-capitalize"> شماره موبایل : </label>
          <b-form-input  id="mobile" v-model="serviceInput.mobile" type="text" />
           <ErrorMessage
            errorType="name"
            :errorMessages="errorMessage"
          ></ErrorMessage>
        </b-form-group>
        <b-form-group class="mt-1">
          <label for="slug" class="text-capitalize"> شماره تلفن دفتر : </label>
          <b-form-input  id="phone" v-model="serviceInput.phone" type="text" />
            <ErrorMessage
            errorType="slug"
            :errorMessages="errorMessage"
          ></ErrorMessage>
        </b-form-group>
        <b-form-group class="mt-1 col-md-6" v-slot="{ ariaDescribedby }">
          <label for="province_status" class="text-capitalize">
            کدام شماره نمایش داده شود ؟  </label>
          <b-form-checkbox
            v-model="serviceInput.show"
            :aria-describedby="ariaDescribedby"
            value="active"
            >شماره موبایل</b-form-checkbox
          >
          <b-form-checkbox
            v-model="serviceInput.show"
            :aria-describedby="ariaDescribedby"
            value="inactive"
            >شماره دفتر</b-form-checkbox
          >
          <ErrorMessage
            errorType="status"
            :errorMessages="errorMessage"
          ></ErrorMessage>
        </b-form-group>
        <b-form-group class="mt-1">
          <label for="description" class="text-capitalize"> ساعت پشتیبانی  : </label>
          <b-form-input
            id="description"
            v-model="serviceInput.timer"
            type="text"
            @input="removeErrors('timer')"
          />
          <ErrorMessage
            errorType="description"
            :errorMessages="errorMessage"
          ></ErrorMessage>
        </b-form-group>
        <b-form-group class="mt-1">
          <label for="description" class="text-capitalize"> آدرس  : </label>
          <b-form-input
              id="description"
              v-model="serviceInput.address"
              type="text"
              @input="removeErrors('address')"
          />
          <ErrorMessage
              errorType="description"
              :errorMessages="errorMessage"
          ></ErrorMessage>
        </b-form-group>
        <b-form-group class="">
          <label for="imageIcon" class="text-capitalize">
            آپلود تصویر ایکون:
          </label>
          <FilePicker
            @inputFile="inputIconImageFile"
            :url="iconImageurl"
            ref="iconImageFilePicker"
          ></FilePicker>
          <ErrorMessage
            errorType="image"
            :errorMessages="errorMessage"
          ></ErrorMessage>
        </b-form-group>
      </b-container>
      <template #footer>
        <div class="d-flex align-items-center justify-content-end px-2 py-1">
          <b-button
            class="text-capitalize mr-2"
            @click="formModal = false"
            variant="outline-dark"
          >
            {{ $t("cancel") }}
          </b-button>
          <b-button variant="primary" @click="submitForm()">
            <div v-if="submitLoading" class="px-1">
              <b-spinner small style="width: 1.3rem; height: 1.3rem" />
              <span class="sr-only">Loading...</span>
            </div>
            <span v-else class="text-capitalize">
              {{ $t("submit") }}
            </span>
          </b-button>
        </div>
      </template>
    </b-sidebar>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BCard,
  BAvatar,
  BButton,
  BSpinner,
  BSidebar,
  BContainer,
  BFormTextarea,
  BFormCheckbox,
  BTableSimple,
  BThead,
  BTbody,
  BTr,
  BTh,
  BTd,
} from "bootstrap-vue";
import PerPage from "@/components/PerPage.vue";
import Breadcrumb from "@/components/Breadcrumb.vue";
import Pagination from "@/components/Pagination.vue";
import Search from "@/components/Search.vue";
import TableHead from "@/components/TableHead.vue";
import vSelect from "vue-select";
import ErrorMessage from "@/components/ErrorMessage.vue";
import FilePicker from "@/components/FilePicker.vue";

export default {
  components: {
    BRow,
    BCol,
    PerPage,
    BFormGroup,
    BFormInput,
    BCard,
    BAvatar,
    BButton,
    Breadcrumb,
    Pagination,
    Search,
    TableHead,
    BSpinner,
    BSidebar,
    BContainer,
    BFormTextarea,
    vSelect,
    ErrorMessage,
    BFormCheckbox,
    FilePicker,
    BTableSimple,
    BThead,
    BTbody,
    BTr,
    BTh,
    BTd,
  },
  data() {
    return {
      iconImageurl:"",
      errorMessage: {},
      perPage: 10,
      page: 1,
      buildings: [],
      services: null,
      defaultAvatar: require("@/assets/images/avatars/default.png"),
      cancelToken: undefined,
      sortBy: "",
      sortDir: "",
      searchInput: "",
      paginationData: null,
      tableHeadings: [
        {
          title: "تصویر آیکن",
          slug: "image_icon",
          sortable: false,
        },
        {
          title: "آیکن",
          slug: "icon",
          sortable: false,
        },
        {
          title: "عنوان",
          slug: "name",
          sortable: true,
        },
        {
          title: "توضیحات",
          slug: "description",
          sortable: true,
        },
        {
          title: "تاریخ ایجاد",
          slug: "created_at",
          sortable: true,
        },

        {
          title: "وضعیت",
          slug: "status",
          sortable: false,
        },
        {
          title: "actions",
          sortable: false,
        },
      ],

      OpenIndicator: {
        render: (createElement) =>
          createElement("feather-icon", { attrs: { icon: "ChevronDownIcon" } }),
      },
      companies: [],
      buildingsCancelToken: undefined,
      serviceInput: {
        id: "",
        mobile: "",
        phone:"",
        show: "",
        address:"",
        image: null,
        timer: "",
      },
      editMode: false,
      formModal: false,
      submitLoading: false,
    };
  },
  mounted() {
    this.$store.commit("verticalMenu/UPDATE_VERTICAL_MENU_COLLAPSED", false);
    this.getServices();
  },
  watch: {
    searchInput(value) {
      this.page = 1;
      this.getServices();
    },
    perPage(value) {
      this.page = 1;
      this.getServices();
    },
    page(value) {
      this.getServices();
    },
  },
  methods: {
    inputIconImageFile(file) {
      this.removeErrors("image");
      this.serviceInput.image = file;
    },
    removeErrors(data) {
      if (
        typeof this.errorMessage[data] !== "undefined" &&
        this.errorMessage[data].length > 0
      ) {
        // this.errorMessage[data][0]="salllam"
        delete this.errorMessage[data];
        this.errorMessage = Object.assign(
          {},
          this.errorMessage,
          this.errorMessage
        );
        console.log(data, this.errorMessage);
      }
    },
    sort(args) {
      this.page = 1;
      this.sortBy = args.sortBy;
      this.sortDir = args.sortDir;
      this.getServices();
    },

    async getServices() {
      if (typeof this.cancelToken != typeof undefined) {
        this.cancelToken.cancel("Operation canceled due to new request.");
      }
      //Save the cancel token for the current request
      this.cancelToken = this.$http.CancelToken.source();

      let data = {
        // search: this.searchInput,
        // per_page: this.perPage,
        // page: this.page,
        // sort_by: this.sortBy,
        // sort_dir: this.sortDir,
      };

      const requestData = {
        method: "get",
        url: "/admin/settings",
        // params: data,
        // cancelToken: this.cancelToken.token,
      };
      this.$http(requestData)
        .then((response) => {
          let data = response.data;
          this.services = data.data;
          this.paginationData = data.meta;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    showConfirmModal(service) {
      this.$bvModal
        .msgBoxConfirm(
          `آیا از حذف تنظیمات مطمئن هستید ؟  : ${service.name}.`,
          {
            title: this.$t("Please Confirm"),
            size: "sm",
            okVariant: "primary",
            okTitle: this.$t("Yes"),
            cancelTitle: this.$t("No"),
            cancelVariant: "outline-secondary",
            hideHeaderClose: false,
            centered: true,
          }
        )
        .then(async (confirmed) => {
          if (confirmed) {
            let residenceIndex = 0;
            this.services = await this.services.filter(
              (residenceItem, index) => {
                if (residenceItem.id == service.id) {
                  residenceIndex = index;
                }
                return residenceItem.id !== service.id;
              }
            );

            const requestData = {
              method: "delete",
              url: `/admin/settings/${service.id}`,
            };
            this.$http(requestData)
              .then((response) => {
                this.$bvToast.toast(
                  `تنظیمات: ${service.name}  با موفقیت حذف شد.`,
                  {
                    title: this.$t("Done"),
                    variant: "success",
                    solid: true,
                  }
                );
              })
              .catch((err) => {
                let message = this.$t("Unable to delete!");
                if (
                  err.response &&
                  err.response.data &&
                  err.response.data.message
                )
                  message = err.response.data.message;
                this.$bvToast.toast(message, {
                  title: this.$t("Error"),
                  variant: "danger",
                  solid: true,
                });
                this.services.splice(residenceIndex, 0, service);
              });
          }
        });
    },
    showFormModal(service) {
      if (service) {
        this.serviceInput = {
          id: service.id,
          mobile: service.mobile,
          phone:service.phone,
          show: service.show,
          address: service.address,
          image: null,
          timer: service.timer,
        };
        this.$refs.iconImageFilePicker.clearFileInput()
        this.iconImageurl=service.image.path
        this.editMode = true;
      } else {
        this.serviceInput = {
          mobile: "",
          phone: "",
          show: "",
          address: "",
          image: "",
          timer: "",
        };
        this.$refs.iconImageFilePicker.clearFileInput()
        this.iconImageurl=""
        this.editMode = false;
      }
      this.formModal = true;
    },
    submitForm() {
      if (this.submitLoading) return;
      let errorMessage = null;
      if (!errorMessage && !this.serviceInput.mobile) {
        errorMessage = "لطفا موبایل  را وارد کنید";
      }
      if (!errorMessage && !this.serviceInput.phone) {
        errorMessage = "لطفا موبایل را وارد کنید";
      }

      let formData = new FormData();

      if (this.serviceInput.mobile) {
        formData.append("mobile", this.serviceInput.mobile);
      }
      if (this.serviceInput.phone) {
        formData.append("phone", this.serviceInput.phone);
      }
      if (this.serviceInput.show) {
        formData.append("show", this.serviceInput.show);
      }
      if (this.serviceInput.address) {
        formData.append("address", this.serviceInput.address);
      }
      if (this.serviceInput.image) {
        formData.append("image", this.serviceInput.image);
      }
      if (this.serviceInput.timer) {
        formData.append("timer", this.serviceInput.timer);
      }
      if (errorMessage) {
        this.$bvToast.toast(errorMessage, {
          title: this.$t("Error"),
          variant: "danger",
          solid: true,
        });
        return;
      }

      this.submitLoading = true;

      const requestData = {
        method: this.editMode ? "post" : "post",
        url: this.editMode
          ? `/admin/settings/update/${this.serviceInput.id}`
          : `/admin/settings`,
        data: formData,
      };

      this.$http(requestData)
        .then((response) => {
          let message = "تنظیمات با موفقیت اضافه شد";
          if (this.editMode) message = "تنظیمات با موفقیت ویرایش شد";
          this.$bvToast.toast(message, {
            title: this.$t("Done"),
            variant: "success",
            solid: true,
          });

          this.submitLoading = false;
          this.formModal = false;
          this.getServices();
        })
        .catch((err) => {
          let message = "خطا در ایجاد تنظیمات";
          if (this.editMode) message = "خطا در ویرایش تنظیمات";
          //  this.errorMessage = err.response.data.response.meta.errors;
         // console.log("this.errorMessage", this.errorMessage);

          this.$bvToast.toast(message, {
            title: this.$t("Error"),
            variant: "danger",
          });
          this.submitLoading = false;
          console.log(err);
        });
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
